import { render, staticRenderFns } from "./three.vue?vue&type=template&id=0b2226ab&scoped=true&"
import script from "./three.vue?vue&type=script&lang=ts&"
export * from "./three.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2226ab",
  null
  
)

export default component.exports